var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.245,
    height: 55.966,
    viewBox: "0 0 62.245 55.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 62.245,
    height: 55.966,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 31.82,
    height: 16.312,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_281",
    "data-name": "Groupe 281",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_280",
    "data-name": "Groupe 280",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_279",
    "data-name": "Groupe 279",
    transform: "translate(0.635 4.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_278",
    "data-name": "Groupe 278",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_277",
    "data-name": "Groupe 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_276",
    "data-name": "Groupe 276",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_577",
    "data-name": "Trac\\xE9 577",
    d: "M37.208,10.459a.218.218,0,0,1,.216.212.22.22,0,0,1-.216.22.216.216,0,0,1-.218-.217.222.222,0,0,1,.216-.22Z",
    transform: "translate(-5.604 -6.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_578",
    "data-name": "Trac\\xE9 578",
    d: "M37.419,10.7l-.044,7.511A.212.212,0,0,0,37.163,18l-.006,0a.215.215,0,0,0-.212.217l.04-7.509a.215.215,0,0,0,.218.217.222.222,0,0,0,.216-.22",
    transform: "translate(-5.598 -6.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_579",
    "data-name": "Trac\\xE9 579",
    d: "M37.163,19.134a.213.213,0,0,1,.212.215.221.221,0,0,1-.216.22.219.219,0,0,1-.214-.22.215.215,0,0,1,.212-.217Z",
    transform: "translate(-5.598 -7.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_580",
    "data-name": "Trac\\xE9 580",
    d: "M32.561,10.009a.217.217,0,0,0-.216-.212l0-.005a.22.22,0,0,0-.216.22c.005-1-1.6-2.009-4.415-2.776A44.778,44.778,0,0,0,16.695,5.958,43.688,43.688,0,0,0,5.663,7.113c-2.819.738-4.439,1.731-4.447,2.725A.219.219,0,0,0,1,9.619l0,0a.216.216,0,0,0-.214.213C.791,8.27,3.381,7.261,5.552,6.7A44.514,44.514,0,0,1,16.7,5.526a45.245,45.245,0,0,1,11.13,1.291c2.163.591,4.742,1.629,4.735,3.193",
    transform: "translate(-0.74 -5.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_581",
    "data-name": "Trac\\xE9 581",
    d: "M.8,10.556a.179.179,0,0,1-.016-.087A.216.216,0,0,1,1,10.257l0,0a.22.22,0,0,1,.214.22.217.217,0,0,1-.416.082",
    transform: "translate(-0.74 -6.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_582",
    "data-name": "Trac\\xE9 582",
    d: "M.733,18.014.777,10.5a.175.175,0,0,0,.016.087.214.214,0,0,0,.2.132L.951,17.8a.223.223,0,0,0-.218.215",
    transform: "translate(-0.733 -6.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_583",
    "data-name": "Trac\\xE9 583",
    d: "M.985,17.8l.04-7.078a.212.212,0,0,0,.217-.215L1.2,18.018a.233.233,0,0,0-.018-.08.219.219,0,0,0-.2-.138",
    transform: "translate(-0.767 -6.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_584",
    "data-name": "Trac\\xE9 584",
    d: "M1.169,19.149a.219.219,0,0,1-.432.043c0-.016,0-.029,0-.046a.224.224,0,0,1,.218-.215.221.221,0,0,1,.2.138.261.261,0,0,1,.017.08",
    transform: "translate(-0.733 -7.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_585",
    "data-name": "Trac\\xE9 585",
    d: "M16.945,23.238c9.056,0,15.122-1.99,15.136-3.882a.215.215,0,1,0,.429,0c-.013,2.437-6.827,4.315-15.57,4.316-.113,0-.226,0-.343,0-8.851-.051-15.787-2-15.86-4.444a.219.219,0,0,0,.432-.043C1.158,21.1,7.358,23.188,16.6,23.236c.113,0,.23,0,.344,0",
    transform: "translate(-0.734 -7.36)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_586",
    "data-name": "Trac\\xE9 586",
    d: "M16.877,14.91h-.32C8.339,14.864.029,13.083.048,9.768s8.332-5,16.564-4.958S33.14,6.636,33.122,9.951c-.018,3.272-8.133,4.959-16.245,4.959m-.615-8.37C6.9,6.54,1.785,8.666,1.779,9.778s5.207,3.347,14.788,3.4c9.608.03,14.817-2.111,14.824-3.237S26.183,6.594,16.6,6.541h-.341",
    transform: "translate(-0.006 -0.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_587",
    "data-name": "Trac\\xE9 587",
    d: "M16.829,24.222h-.321C8.291,24.176-.018,22.4,0,19.08a.867.867,0,0,1,.866-.861H.871a.866.866,0,0,1,.86.871c-.006,1.126,5.208,3.347,14.787,3.4h.341c9.364,0,14.478-2.125,14.484-3.238a.864.864,0,0,1,.866-.86h0a.867.867,0,0,1,.862.87c-.018,3.272-8.134,4.959-16.246,4.959",
    transform: "translate(0 -2.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_588",
    "data-name": "Trac\\xE9 588",
    d: "M37.073,18.985h-.005a.865.865,0,0,1-.86-.871l.042-7.51a.866.866,0,0,1,.866-.86h.005a.866.866,0,0,1,.86.871l-.042,7.51a.865.865,0,0,1-.866.86",
    transform: "translate(-4.864 -1.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_589",
    "data-name": "Trac\\xE9 589",
    d: "M.866,18.785H.86A.865.865,0,0,1,0,17.914L.042,10.4a.866.866,0,0,1,.866-.86H.912a.866.866,0,0,1,.86.871l-.042,7.51a.865.865,0,0,1-.866.86",
    transform: "translate(0 -1.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_590",
    "data-name": "Trac\\xE9 590",
    d: "M21.732,27.576H21.4c-8.218-.046-16.528-1.827-16.509-5.141a2.082,2.082,0,0,1,.128-.7.866.866,0,0,1,1.625.6.326.326,0,0,0-.022.11c-.006,1.126,5.207,3.347,14.788,3.4h.34c9.364,0,14.477-2.125,14.483-3.238,0-.411-.984-1.3-3.71-2.081A.865.865,0,1,1,33,18.862c3.306.941,4.978,2.2,4.968,3.755-.019,3.421-8.365,4.959-16.235,4.959",
    transform: "translate(-0.657 -2.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_591",
    "data-name": "Trac\\xE9 591",
    d: "M21.673,36.678h-.32c-8.218-.046-16.528-1.826-16.509-5.141a.866.866,0,0,1,.866-.861h0a.867.867,0,0,1,.861.871c-.006,1.126,5.207,3.347,14.788,3.4s14.817-2.111,14.824-3.237a.865.865,0,0,1,.866-.86h0a.866.866,0,0,1,.861.87c-.018,3.272-8.133,4.959-16.245,4.959",
    transform: "translate(-0.651 -4.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_592",
    "data-name": "Trac\\xE9 592",
    d: "M41.917,31.441h-.005a.865.865,0,0,1-.86-.871l.042-7.51a.866.866,0,0,1,.866-.86h.005a.866.866,0,0,1,.86.871l-.042,7.51a.865.865,0,0,1-.866.86",
    transform: "translate(-5.515 -2.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_593",
    "data-name": "Trac\\xE9 593",
    d: "M5.71,31.241H5.7a.865.865,0,0,1-.86-.871l.042-7.51A.866.866,0,0,1,5.751,22h.005a.866.866,0,0,1,.86.871l-.042,7.51a.865.865,0,0,1-.866.86",
    transform: "translate(-0.651 -2.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_594",
    "data-name": "Trac\\xE9 594",
    d: "M17.124,38.188h-.337A45.8,45.8,0,0,1,5.49,36.87C2.023,35.924.269,34.637.278,33.047c.009-1.471,1.528-2.668,4.515-3.56a.865.865,0,1,1,.5,1.659c-2.589.774-3.277,1.588-3.279,1.911,0,.429,1.044,1.355,3.936,2.143A44.041,44.041,0,0,0,16.8,36.456c7.375.068,12.861-1.309,14.433-2.664A.866.866,0,0,1,32.362,35.1c-2.152,1.855-8.25,3.085-15.238,3.085",
    transform: "translate(-0.037 -3.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_595",
    "data-name": "Trac\\xE9 595",
    d: "M17.069,47.288H16.74a45.811,45.811,0,0,1-11.3-1.317C1.975,45.025.222,43.737.231,42.146a.866.866,0,0,1,.866-.861H1.1a.867.867,0,0,1,.86.871c0,.429,1.044,1.356,3.936,2.144A44.041,44.041,0,0,0,16.75,45.556c5.57.027,10.733-.741,13.386-2.015a.866.866,0,0,1,.751,1.561c-2.82,1.355-8.093,2.187-13.818,2.187",
    transform: "translate(-0.031 -5.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_596",
    "data-name": "Trac\\xE9 596",
    d: "M37.33,40.2h0a.865.865,0,0,1-.863-.868l.013-4.393a.866.866,0,0,1,.866-.863h0a.866.866,0,0,1,.863.868L38.2,39.339a.866.866,0,0,1-.866.863",
    transform: "translate(-4.899 -4.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_597",
    "data-name": "Trac\\xE9 597",
    d: "M1.1,41.851H1.09a.865.865,0,0,1-.86-.871l.042-7.51a.867.867,0,0,1,.866-.86h.005a.865.865,0,0,1,.86.871l-.042,7.51a.865.865,0,0,1-.866.86",
    transform: "translate(-0.031 -4.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_598",
    "data-name": "Trac\\xE9 598",
    d: "M21.571,51.406h-.4c-7.964-.044-16.529-1.672-16.509-5.141a2.193,2.193,0,0,1,.465-1.313.865.865,0,1,1,1.389,1.031.533.533,0,0,0-.123.292C6.386,47.4,11.6,49.62,21.18,49.674A42.4,42.4,0,0,0,31.32,48.7a.865.865,0,1,1,.412,1.681,42.851,42.851,0,0,1-10.161,1.029",
    transform: "translate(-0.626 -5.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_599",
    "data-name": "Trac\\xE9 599",
    d: "M21.443,60.206h-.32c-8.218-.046-16.528-1.826-16.509-5.141a.848.848,0,0,1,.87-.861.867.867,0,0,1,.861.871c-.006,1.126,5.207,3.347,14.788,3.4s14.817-2.111,14.824-3.237a.865.865,0,0,1,.866-.86h0a.866.866,0,0,1,.861.87c-.018,3.272-8.133,4.959-16.245,4.959",
    transform: "translate(-0.62 -7.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_600",
    "data-name": "Trac\\xE9 600",
    d: "M5.479,54.769H5.473a.865.865,0,0,1-.86-.871l.042-7.51a.866.866,0,0,1,.866-.86h.005a.866.866,0,0,1,.86.871l-.042,7.51a.865.865,0,0,1-.866.86",
    transform: "translate(-0.62 -6.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_601",
    "data-name": "Trac\\xE9 601",
    d: "M63.551,54.118c-3.419,0-8.711-1.705-13.629-4.082a45.8,45.8,0,0,1-9.634-6.047c-2.723-2.344-3.753-4.26-3.061-5.693,1.442-2.985,9.688-.929,17.087,2.646a45.831,45.831,0,0,1,9.633,6.047c2.724,2.345,3.753,4.261,3.062,5.693-.484,1-1.732,1.436-3.458,1.436m-23-15.558c-1.013,0-1.621.186-1.768.488-.187.388.36,1.672,2.632,3.629a44.076,44.076,0,0,0,9.256,5.8c8.626,4.167,14.286,4.464,14.776,3.452.187-.387-.36-1.672-2.632-3.628a44.062,44.062,0,0,0-9.257-5.8c-6.047-2.921-10.635-3.941-13.007-3.941",
    transform: "translate(-4.973 -4.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_602",
    "data-name": "Trac\\xE9 602",
    d: "M59.771,62.115c-3.469,0-8.821-1.8-13.622-4.119a45.816,45.816,0,0,1-9.634-6.047c-2.723-2.345-3.753-4.261-3.06-5.693a.865.865,0,1,1,1.558.752c-.186.387.36,1.672,2.632,3.628a44.089,44.089,0,0,0,9.256,5.8C55.53,60.6,61.188,60.9,61.677,59.89a.866.866,0,1,1,1.559.752c-.5,1.033-1.752,1.472-3.465,1.472",
    transform: "translate(-4.466 -6.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_603",
    "data-name": "Trac\\xE9 603",
    d: "M66.854,62.2a.866.866,0,0,1-.778-1.242l3.266-6.763a.866.866,0,1,1,1.559.752l-3.267,6.763a.865.865,0,0,1-.78.489",
    transform: "translate(-8.865 -7.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_604",
    "data-name": "Trac\\xE9 604",
    d: "M34.252,46.449a.866.866,0,0,1-.778-1.242l3.266-6.763A.866.866,0,0,1,38.3,39.2L35.032,45.96a.865.865,0,0,1-.78.489",
    transform: "translate(-4.485 -5.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_605",
    "data-name": "Trac\\xE9 605",
    d: "M44.425,12.453a.866.866,0,0,1-.747-1.3L49.932.429a.866.866,0,0,1,1.5.873L45.174,12.024a.867.867,0,0,1-.749.429",
    transform: "translate(-5.852 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_606",
    "data-name": "Trac\\xE9 606",
    d: "M49.393,22.213a.866.866,0,0,1-.263-1.691l9.83-3.128a.866.866,0,1,1,.525,1.65l-9.829,3.128a.873.873,0,0,1-.263.041",
    transform: "translate(-6.519 -2.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_607",
    "data-name": "Trac\\xE9 607",
    d: "M60.82,36.392a.853.853,0,0,1-.321-.061l-11.17-4.468a.866.866,0,0,1,.642-1.608l11.17,4.468a.866.866,0,0,1-.321,1.67",
    transform: "translate(-6.554 -4.056)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalets);
export default __webpack_public_path__ + "static/media/GALETS.642056a5251b6935a2f19c2f597d131e.svg";
export { ForwardRef as ReactComponent };